export default __webpack_public_path__ + "static/media/Intermedium.6f2aebd6.woff";